module.exports = __webpack_public_path__ + "static/img/info.7bc95e6f.svg";